export const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    str = String(str).trim();
    return str.charAt(0).toUpperCase() + str.slice(1);
};


// WEBPACK FOOTER //
// ./src/components/partials/utils.js